import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box
} from '@mui/material'
import ErrorMessage from '../../../component/shared/component/ErrorMessage'
import { useGetSalesIncentives } from '../../../api/sales-commission-incentive'
import IncentiveRow from './IncentiveRow'
import { LoadingSkeletonRows } from '../../shared/LoadingSkeletonRows'
import IncentiveDialog from './IncentiveDialog'
import IncentiveImport from './IncentiveImport'
import { useGetSalesIds } from '../../../api/sales'

const IncentiveTable = ({
  search,
  monthYear,
  onEdit,
  openDialog,
  setOpenDialog,
  editData,
  openImport,
  setOpenImport
}) => {
  const {
    data: incventives = [],
    isLoading,
    refetch
  } = useGetSalesIncentives({ search, monthYear })
  const { data: allSalesIds = [], isLoading: isLoadingSalesIds } = useGetSalesIds()

  return (
    <Box>
      {incventives.length || isLoading ? (
        <TableContainer component={Paper}>
          <MuiTable>
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Sales ID</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Month</TableCell>
                <TableCell align='right'>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <LoadingSkeletonRows rows={10} length={5} />
              ) : (
                incventives.map((row) => (
                  <IncentiveRow
                    key={row._id}
                    data={row}
                    onEdit={() => onEdit(row)}
                    refetch={refetch}
                  />
                ))
              )}
            </TableBody>
          </MuiTable>
        </TableContainer>
      ) : (
        <ErrorMessage empty />
      )}
      <IncentiveDialog
        open={openDialog}
        setOpen={setOpenDialog}
        data={editData}
        refetch={refetch}
        allSalesIds={allSalesIds}
        isLoadingSalesIds={isLoadingSalesIds}
      />
      <IncentiveImport open={openImport} setOpen={setOpenImport} refetch={refetch} />
    </Box>
  )
}

export default IncentiveTable
